module.exports = __webpack_public_path__ + "img/bg-info2.34573fb6.png";